// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1njcH","title":"styles_title__27YIT"};